module.exports = __webpack_public_path__ + "static/media/m-rabbitTrain.ce1f750b.png";